export default "__VITE_ASSET___nZHjlVS__"